import { render, staticRenderFns } from "./404View.vue?vue&type=template&id=521e7c8c&scoped=true&"
import script from "./404View.vue?vue&type=script&lang=js&"
export * from "./404View.vue?vue&type=script&lang=js&"
import style0 from "./404View.vue?vue&type=style&index=0&id=521e7c8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521e7c8c",
  null
  
)

export default component.exports